import React, {useState} from 'react';
import { useNavigate } from 'react-router';
import { useApi } from '../../api/ApiProvider';
import Api from '../../axiosApi/api';
import { useToastMessageQueue } from '../ToastMessages/ToastMessageProvider';
import '../../scss/Invoice/InvoicesRow.scss';
import Chip from '@mui/material/Chip';
import { HiEye } from 'react-icons/hi';
import WorkflowActionsBar from '../Workflow/WorkflowActionsBar';

const InvoicesRow = ({ className, date, from, to, invoiceNumber, invoiceID, amount, status, idWorkflowState, idInvoiceType, addressFrom, addressTo, idFrom, idTo, idCurrency, invoiceItems, fileURI, invoiceTaxes, OwnerView, isValidating, jobId }) => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(false);

    const color = status === "Pending" || status === "Pendiente" ? "warning" : status === "Approved" || status === "Aprobado" ? "success" : status === "Observed" || status === "Observado" ? "default" : status === "Open" || status === "Abierto" ? "primary" : status === "Reopen" || status === "Reabrir" ? "secondary" : "error";

    const handleInvoiceDetail = () => {
        if (isValidating) {
            navigate(`/accountspayable/validate/${jobId}`);
        } else {
            navigate(`/invoice/detail/${invoiceID}`);
        }
    };

    const path = window.location.pathname.split('/').pop();
    const handleSave = () => {};

    return (
        <tr className={className} style={{cursor: "default"}}>
            {
                (OwnerView || isValidating) ?
                <td>{from === null || from === "" ? '-' : from}</td> :
                null
            }
            <td>{date}</td>
            <td>{invoiceNumber}</td>
            {!isValidating ? <td>{invoiceID}</td> : null}
            <td style={{ width: '120px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', paddingRight: '20px' }}>
                    <span style={{ marginRight: '2px' }}>$</span>
                    <span style={{ textAlign: 'right', flex: 1 }}>{Number(amount).toFixed(2)}</span>
                </div>
            </td>
            <td>
                <Chip label={isValidating ? "Validating" : status} color={isValidating ? "info" : color} className={color === "default" ? 'observed' : ''}/>
            </td>
            {!isValidating ? <td className='text-center'>
                <WorkflowActionsBar viewMode='icons' onActionClick={handleSave} id={invoiceID} stateId={idWorkflowState} loading={loading}/>
            </td> : null}
            {((!isValidating && path === 'myInvoices') || (path === 'accountspayable') || (path === 'invoicing')) && (
                <td className='text-center'>
                    <a className='td-icon mx-1' title="Detail" style={{cursor: "pointer"}}>
                        <HiEye onClick={() => handleInvoiceDetail()}/>
                    </a>
                </td>
            )}
        </tr>
    )
}

export default InvoicesRow;
